<template>
<div class="xin">

    <!-- tab 切换  -->
    <div class="switch" v-show="local_seven" v-loading="loading">
        <!-- 面包屑 -->
        <div class="main-find ">
            <span> {{ $t("logs.loacalsendmsg_a1") }}:</span>
            <el-input v-model="num" style="width:5%" @change="change_input"></el-input>
            <span> IP24:</span>

            <el-input v-model="ip24" style="width:14%" @change="change_input1" clearable></el-input>

            <el-select v-model="salt_minion_ip" placeholder="请选择" @change="change1" style="width:12%;margin-right:10px" v-if="this.has_min==1">
                <el-option v-for="item in salt_minion_ipp" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <span>{{ $t("logs.loacalsendmsg_a2") }}:</span>
            <el-select v-model="showtime" placeholder="请选择" style="width:10%;margin-right:10px" @change="change2">
                <el-option v-for="item in showtimee" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <!-- 指定某天-->
            <el-date-picker v-model="oneday" type="date" placeholder="" class="one_day" style="width:12%;margin-right:10px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-show="time_oneday" :picker-options="pickerOptions" @change="oneday_day">
            </el-date-picker>
            <!-- 自定义某天-->
            <el-date-picker v-model="startday" type="date" placeholder="" class="one_day" style="width:12%;margin-right:10px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-show="time_startday" :picker-options="pickerOptions">
            </el-date-picker> <span v-show="time_startday">{{$t('wasteInsulate1.zhi')}}</span>
            <el-date-picker v-model="endday" type="date" placeholder="" class="one_day" style="width:12%;margin-right:10px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-show="time_startday" :picker-options="pickerOptions">
            </el-date-picker>

            <el-button @click="save_send_search()" v-show="time_startday">{{ $t("logs.ldap8") }}</el-button>
        </div>
        <el-tabs @tab-click="dianji">
            <!-- 连接数  -->
            <el-tab-pane label="邮件数">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg13") }}
                </span>
                <div class="switch1">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>

                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 实施日志-->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 邮件数 -->
            <el-tab-pane label="大站点数">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg1") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 收件人数 -->
            <el-tab-pane label="字节数">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg4") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 字节数 -->
            <el-tab-pane label="收件人数">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg3") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 退信数 -->
            <el-tab-pane label="对外域消息">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg11") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>

            <!-- 认证失败数 -->
            <el-tab-pane label="对外域字节数">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg14") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 认证失败数 -->
            <el-tab-pane label="对外域字节数">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg15") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 拒绝数 -->
            <el-tab-pane label="对外域收件人">
                <span slot="label">

                    {{ $t("logs.loacalsendmsg12") }}
                </span>
                <div class="switch1" v-loading="loading">
                    <div class="main">
                        <p class="main_style_family">
                            {{this.search_show1}}
                            <span>{{this.search_show2}}</span>
                        </p>
                    </div>
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="60"></el-table-column>
                            <el-table-column prop="IP" label="Peerip" width="120"></el-table-column>
                            <el-table-column prop="NUM" :label="$t('logs.loacalsendmsg1_a1')" width="80"></el-table-column>
                            <el-table-column prop="UPDATETIME" :label="$t('logs.loacalsendmsg1_a2')" width="150"></el-table-column>
                            <el-table-column prop="VIEW24" :label="$t('logs.loacalsendmsg1_a3')"></el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="180">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a5") }}
                                    </el-button>
                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.archive_search==1">
                                        {{ $t("logs.loacalsendmsg1_a6") }}
                                    </el-button>
                                    <el-button @click="handleClick3(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("logs.loacalsendmsg1_a7") }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

    </div>
    <div class="switch fenye_table" v-show="tanchu_one">

        <!-- 查询框 -->
        <div class="main">

            <el-button @click="save_sender_hide()">{{ $t("logs.Policy_back") }}</el-button>


        </div>

        <!--  表格 -->
        <div>
            <div class="table">
                <el-table v-loading="loading" :data="fileList2" :row-class-name="tableRowClassName" ref="multipleTable" tooltip-effect="dark" style="width: 100%">

                    <el-table-column :label="$t('table.tls')" width="40">
                        <template slot-scope="scope">
                            <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt />
                        </template>
                    </el-table-column>
                    <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="92"></el-table-column>
                    <el-table-column prop="SHOW_MINION" :label="$t('table.clusterhost')" width="96"></el-table-column>
                    <el-table-column prop="MID" :label="$t('table.ID')" width="102"></el-table-column>
                    <el-table-column prop="IP" :label="$t('table.IP')" width="102"></el-table-column>
                    <el-table-column prop="REJ_STAGE" :label="$t('wasteInsulate1.stage')" width="94"></el-table-column>
                    <!--  发件人 -->

                    <el-table-column prop="ENVFROM" :label="$t('table.ENVFROM')" width="140">

                    </el-table-column>

                    <!--  收件人 -->

                    <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="140">

                    </el-table-column>
                    <el-table-column prop="WHY" :label="$t('wasteInsulate1.status')" width="140">
                    </el-table-column>
                    <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')">

                    </el-table-column>

                </el-table>
            </div>

            <!--  分页 -->
            <div class="fenye">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
            </div>
        </div>
    </div>
    <div class="switch fenye_table" v-show="tanchu_two">

        <!-- 查询框 -->
        <div class="main">

            <el-button @click="save_sender_hide2()">{{ $t("logs.Policy_back") }}</el-button>

            <el-alert :title="this.HINT_QUERY_DETAIL" type="warning" show-icon :closable="false"></el-alert>

        </div>

        <!--  表格 -->
        <div>
            <div class="table">
                <el-table v-loading="loading" :data="fileList3" :row-class-name="tableRowClassName" ref="multipleTable" tooltip-effect="dark" style="width: 100%">

                    <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="92"></el-table-column>

                    <el-table-column prop="IP" :label="$t('table.IP')" width="102"></el-table-column>
                    <el-table-column prop="IP" :label="$t('table.ID')" width="102"></el-table-column>
                    <!--  发件人 -->

                    <el-table-column prop="ENVFROM" :label="$t('table.ENVFROM')" width="140">

                    </el-table-column>

                    <!--  收件人 -->

                    <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="140">

                    </el-table-column>

                    <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')">

                    </el-table-column>

                    <el-table-column prop="SIZE" :label="$t('table.mailsize')" width="64">
                    </el-table-column>

                </el-table>
            </div>

            <!--  分页 -->
            <div class="fenye">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
            </div>
        </div>
    </div>
    <div class="switch fenye_table" v-show="tanchu_three">

        <!-- 查询框 -->
        <div class="main">

            <el-button @click="save_sender_hide3()">{{ $t("logs.Policy_back") }}</el-button>

            <el-alert :title="this.HINT_QUERY_DETAIL" type="warning" show-icon :closable="false"></el-alert>

        </div>

        <!--  表格 -->
        <div>
            <div class="table">
                <el-table v-loading="loading" :data="fileList4" :row-class-name="tableRowClassName" ref="multipleTable" tooltip-effect="dark" style="width: 100%">

                    <el-table-column prop="IP_CONNECT" :label="$t('logs.loacalsendmsg13')" width="126"></el-table-column>
                    <el-table-column prop="IP_MESSAGE" :label="$t('logs.loacalsendmsg1')" width="96"></el-table-column>

                    <el-table-column prop="IP_RECIPIENT" :label="$t('logs.loacalsendmsg4')" width="102"></el-table-column>
                    <!--  发件人 -->

                    <el-table-column prop="IP_AUTHOK" :label="$t('logs.loacalsendmsg14')" width="140">

                    </el-table-column>

                    <!--  收件人 -->

                    <el-table-column prop="IP_BYTES" :label="$t('logs.loacalsendmsg3')" width="140">

                    </el-table-column>
                    <el-table-column prop="IP_BOUNCE" :label="$t('logs.loacalsendmsg11')" width="140">

                    </el-table-column>
                    <el-table-column prop="IP_AUTHFAIL" :label="$t('logs.loacalsendmsg15')">

                    </el-table-column>

                    <el-table-column prop="IP_NB_REJECT" :label="$t('logs.loacalsendmsg12')" width="64">
                    </el-table-column>

                </el-table>
            </div>

        </div>
    </div>
    <!-- 弹出框1-->
</div>
</template>

<script>
export default {
    data() {
        return {
            is_byte:'',
            archive_search: '',
            has_min: '',
            HINT_QUERY_DETAIL: '',
            pickerOptions: {
                disabledDate(time) {
                    // return time.getTime() > Date.now();
                    return time.getTime() > (Date.now() - (24 * 60 * 60 * 1000));
                },
            },
            ip24: '',
            endday: '',
            time_oneday: false,
            time_startday: false,
            startday: '',
            oneday: '',
            local_seven_detail: false,
            local_seven: true,
            salt_minion_ip: '127.0.0.1',
            salt_minion_ipp: [],
            showtime: 1,
            showtimee: [],
            num: "",
            input: "",
            fileList1: [],
            fileList: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],
            search_show1: '',
            search_show2: '',
            tab_num: '',
            loading: false,
            // 总数
            totalnums: 0,
            size: 0,
            // 每页条数
            pagesize: 0,
            //   默认前往第几页
            page: 0,
            col: {
                email: "",
            },
            email: '',
            tanchu1: false,
            tanchu2: false,
            tanchu3: false,
            tanchu: false,
            tanchu_two: false,
            tanchu_one: false,
            tanchu_three: false,

        };
    },
    mounted() {
        this.getFileList1();
        // this.getFileList2();
    },
    methods: {
        // 各种详情
        handleClick3(index, scope) {
            this.loading = true
            this.tanchu_three = true
            this.local_seven = false
            // this.local_seven_detail = true

            // console.log(index, scope)
            this.col.ip = scope.IP
            // this.email = this.col.email

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            // let str = this.$qs.stringify({
            //     __mode: "query_sendmsg",
            //     sid: sid,
            //     col: col,

            // });
            // console.log(str, '555')
            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "scan_ip_detail",
                        sid: sid,
                        addr: this.col.ip,
                        salt_minion_ip: this.salt_minion_ip,
                        // salt_minion_ip: this.salt_minion_ip,
                        showtime: this.showtime,
                        oneday: this.oneday,
                        startday: this.startday,
                        endday: this.endday,
                        type: this.tab_num
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList4 = res.data.ret.datalist;
                        // this.totalnums = res.data.ret.col.totalnums;
                        // this.size = res.data.ret.col.pagesize;
                        // this.page = res.data.ret.col.page;
                        this.HINT_QUERY_DETAIL = res.data.ret.SCAN_IP_DETAIL_HINT
                        this.loading = false

                    }
                });

        },
        // 搜索归档
        handleClick2(index, scope) {
            this.tanchu_two = true
            this.local_seven = false
            this.loading = true

            // this.local_seven_detail = true

            console.log(index, scope)
            this.col.ip = scope.IP
            // this.email = this.col.email
            let col = this.col;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            // let str = this.$qs.stringify({
            //     __mode: "query_sendmsg",
            //     sid: sid,
            //     col: col,

            // });
            // console.log(str, '555')
            this.$axios
                .get("/api/adm/cgi/archive.cgi", {
                    params: {
                        __mode: "gate_ac_rec_list",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList3 = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.HINT_QUERY_DETAIL = res.data.ret.HINT_QUERY_DETAIL
                        this.loading = false

                    }
                });

        },
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "real_filterlog",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList2 = res.data.ret.datalist;
                        // 总条数
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;

                        this.loading = false;

                    }
                })
               
        },
        // 当天数据
        handleClick1(index, scope) {
            this.tanchu_one = true
            this.local_seven = false
            this.loading = true

            // this.local_seven_detail = true

            console.log(index, scope)
            this.col.ip = scope.IP
            // this.email = this.col.email
            let col = this.col;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            // let str = this.$qs.stringify({
            //     __mode: "query_sendmsg",
            //     sid: sid,
            //     col: col,

            // });
            // console.log(str, '555')
            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "real_filterlog",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList2 = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.HINT_QUERY_DETAIL = res.data.ret.HINT_QUERY_DETAIL
                        this.loading = false

                    }
                });

        },
        // 只可以选择今天之前的日期

        // 每页显示多少条 -- 切换
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.col.pagesize = val;
            //  this.tanSend()

            // this.tanSend(this.search,this.pagesize)
            this.getFileList();
        },
        // 当前第几页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.col.page = val;
            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '1111', val);
            this.getFileList();
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 返回
        save_sender_hide3() {
            this.tanchu_three = false;
            this.local_seven = true
            this.getFileList1();
        },
        save_sender_hide2() {
            this.tanchu_two = false;
            this.local_seven = true
            this.getFileList1();
        },
        save_sender_hide() {
            this.tanchu_one = false;
            this.local_seven = true
            this.getFileList1();
        },
        save_send_search() {
            this.getFileList1();
        },
        dianji(a) {
            // console.log(a.index)
            this.tab_num = a.index
            this.getFileList1();
        },
        // 邮件数加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            if (this.tab_num == 0) {
                this.tab_num = 'con'
            } else if (this.tab_num == 1) {
                this.tab_num = 'msg'

            } else if (this.tab_num == 2) {
                this.tab_num = 'rcpt'

            } else if (this.tab_num == 3) {
                this.tab_num = 'by'
                this.is_byte=1

            } else if (this.tab_num == 4) {
                this.tab_num = 'bn'

            } else if (this.tab_num == 5) {
                this.tab_num = 'auth'

            } else if (this.tab_num == 6) {
                this.tab_num = 'authfail'

            } else if (this.tab_num == 7) {
                this.tab_num = 'rej'

            }

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "cmd_ip_print_sort",
                        sid: sid,
                        showtime: this.showtime,
                        show_b: this.tab_num,
                        show_a: 'ip',
                        oneday: this.oneday,
                        startday: this.startday,
                        endday: this.endday,
                        salt_minion_ip: this.salt_minion_ip,
                        num: this.num,
                        addr: this.ip24,
                        is_byte:this.is_byte,
                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false
                        // this.getFileList1();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList1 = res.data.ret.datalist;
                        this.search_show1 = res.data.ret.HINT;
                        this.search_show2 = res.data.ret.TOTAL_VALUE;
                        this.num = res.data.ret.num;
                        this.salt_minion_ipp = res.data.ret.q_minion_host;
                        this.showtimee = res.data.ret.q_showtime;

                        if (this.showtime == 1) {

                            this.oneday = res.data.ret.endday
                            this.startday = res.data.ret.startday
                            this.endday = res.data.ret.endday
                        }
                        if (res.data.ret.HAS_MINION) {
                            this.has_min = 1
                        }
                        this.archive_search = res.data.ret.SYS_GATE_ARCHIVE_ON
                        console.log(this.archive_search, ' this.archive_search')

                    }
                })
               
        },
        oneday_day() {
            // console.log(a);
            this.getFileList1();
        },
        change_input(a) {
            // console.log(a);
            this.num = a;
            this.getFileList1();

        },
        change_input1(a) {
            console.log(a);
            this.ip24 = a;
            this.getFileList1();

        },
        // 下拉框点击选中
        change1(a) {
            // console.log(a);
            this.salt_minion_ip1 = a;
            this.getFileList1();

        },
        // 时间区间选中
        change2(a) {
            // console.log(a);
            this.showtime = a;
            if (this.showtime == 4) {
                this.time_oneday = true
                this.time_startday = false

            } else if (this.showtime == 5) {
                this.time_startday = true
                this.time_oneday = false

            } else {
                this.time_oneday = false
                this.time_startday = false

            }
            this.getFileList1();

        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/email_manage.less";

.table01 {

    /deep/ .has-gutter th:nth-child(1) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(6) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(1) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(6) {
        text-align: center;

    }
}

.main-find {
    // width: 100%;
    height: 50px;
    padding-left: 14px;
    // padding-bottom: 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: left;

    border-bottom: 2px solid #D2D7E6;
    // background: #FFFFFF;

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
    }

    .el-input {
        margin-right: 8px;
        width: 20%;
        line-height: 32px;
        height: 32px;
        // padding: 5px 10px 5px 0;

    }

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    /deep/ .el-input--suffix {
        // width: 150px;
        margin-right: 10px;
    }

    /deep/ .el-button {
        margin-right: 10px;
        // margin-left: 30px;
    }
}

//  条件下 搜索 button  按钮
.main-find /deep/ .el-button {
    padding: 8px 10px;

    background: #006BE7;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;

}

.main_style_family {

    font-family: PingFangSC-Medium, PingFang SC;
    color: #0E2C5E;
    font-size: 14px;
}

.fenye_table {
    padding: 14px 0;
}

.fenye_table .table {
    margin-bottom: 0;
}

.one_day {
    /deep/.el-input__inner {
        padding-left: 30px;
    }
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//     width: 0px;
//     background: none;
// }
</style>
